import React, { useEffect, useState, useRef, Component } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MessageCircle, CreditCard, ChevronDown, GraduationCap, CalendarCheck } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
export function Header() {
  const {
    language,
    toggleLanguage,
    t
  } = useLanguage();
  const [payOpen, setPayOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    function handleClickOutside(e: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setPayOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  const whatsappUrl = 'https://wa.me/13472648498?text=' + encodeURIComponent(language === 'es' ? 'Hola Lorena, me gustaría agendar una cita.' : 'Hi Lorena, I would like to book an appointment.');
  return <header className="sticky top-0 z-50 w-full bg-white/95 backdrop-blur-sm border-b border-gold/20 shadow-sm" data-id="element-169">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-170">
        <div className="flex justify-between items-center h-20" data-id="element-171">
          <div className="flex-shrink-0 flex items-center" data-id="element-172">
            <a href="#" data-id="element-173">
              <img src="https://cdn.magicpatterns.com/uploads/f2nJaQykRwe1vHYLG5oJtG/lore_logo.png" alt="Lorena Beauty House Logo" className="h-20 w-auto object-contain mix-blend-multiply" data-id="element-174" />
            </a>
          </div>
          <nav className="hidden md:flex space-x-5 lg:space-x-6 items-center" data-id="element-175">
            <a href="#servicios" className="text-sm font-medium text-dark hover:text-gold transition-colors" data-id="element-176">
              {t('header', 'services')}
            </a>
            <a href="#sobre-lorena" className="text-sm font-medium text-dark hover:text-gold transition-colors" data-id="element-177">
              {t('header', 'about')}
            </a>
            <a href="#testimonios" className="text-sm font-medium text-dark hover:text-gold transition-colors" data-id="element-178">
              {t('header', 'testimonials')}
            </a>
            <a href="#productos" className="text-sm font-medium text-dark hover:text-gold transition-colors" data-id="element-179">
              {t('header', 'products')}
            </a>
            <a href="#espacio" className="text-sm font-medium text-dark hover:text-gold transition-colors" data-id="element-180">
              {t('header', 'space')}
            </a>
            <a href="#formacion" className="text-sm font-medium text-dark hover:text-gold transition-colors" data-id="element-181">
              {t('header', 'training')}
            </a>
            <a href="#contacto" className="text-sm font-medium text-dark hover:text-gold transition-colors" data-id="element-182">
              {t('header', 'contact')}
            </a>

            {/* Language Toggle Desktop */}
            <button onClick={toggleLanguage} className="flex items-center space-x-1 text-sm font-bold border border-gold/30 rounded-full px-3 py-1 hover:bg-gold/10 transition-colors" data-id="element-183">
              <span className={language === 'es' ? 'text-gold-dark' : 'text-dark/50'} data-id="element-184">
                ES
              </span>
              <span className="text-dark/30" data-id="element-185">|</span>
              <span className={language === 'en' ? 'text-gold-dark' : 'text-dark/50'} data-id="element-186">
                EN
              </span>
            </button>

            {/* WhatsApp Agendar Button */}
            <motion.a whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="flex items-center space-x-1 bg-gold hover:bg-gold-dark text-white px-2 lg:px-4 py-1.5 lg:py-2 rounded-sm text-xs lg:text-sm font-medium transition-colors shadow-md whitespace-nowrap" data-id="element-187">
              <MessageCircle className="w-3 lg:w-3.5 h-3 lg:h-3.5" data-id="element-188" />
              <span className="hidden xl:inline" data-id="element-189">{t('header', 'book')}</span>
              <span className="xl:hidden" data-id="element-190">{t('header', 'bookMobile')}</span>
            </motion.a>

            {/* Pagar Dropdown */}
            <div className="relative" ref={dropdownRef} data-id="element-191">
              <motion.button whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} onClick={() => setPayOpen(!payOpen)} className="flex items-center space-x-1 border-2 border-gold text-gold hover:bg-gold hover:text-white px-2 lg:px-3 py-1.5 lg:py-2 rounded-sm text-xs font-medium transition-all whitespace-nowrap" data-id="element-192">
                <CreditCard className="w-3.5 h-3.5 flex-shrink-0" data-id="element-193" />
                <span className="hidden xl:inline" data-id="element-194">
                  {language === 'es' ? 'Pagar' : 'Pay'}
                </span>
                <ChevronDown className={`w-3 h-3 transition-transform duration-300 ${payOpen ? 'rotate-180' : ''}`} data-id="element-195" />
              </motion.button>
              <AnimatePresence data-id="element-196">
                {payOpen && <motion.div initial={{
                opacity: 0,
                y: -8
              }} animate={{
                opacity: 1,
                y: 0
              }} exit={{
                opacity: 0,
                y: -8
              }} transition={{
                duration: 0.2
              }} className="absolute right-0 mt-2 w-64 bg-white border border-gold/20 rounded-sm shadow-xl overflow-hidden z-50" data-id="element-197">
                    <a href="https://buy.stripe.com/bJedR855raja78m6493cc02" target="_blank" rel="noopener noreferrer" className="flex items-center space-x-3 px-5 py-4 hover:bg-beige transition-colors border-b border-gold/10" onClick={() => setPayOpen(false)} data-id="element-198">
                      <CalendarCheck className="w-5 h-5 text-gold flex-shrink-0" data-id="element-199" />
                      <div data-id="element-200">
                        <p className="font-bold text-dark text-sm" data-id="element-201">
                          {language === 'es' ? 'Pagar Cita' : 'Pay Appointment'}
                        </p>
                        <p className="text-xs text-dark/50" data-id="element-202">
                          {language === 'es' ? 'Pago seguro con Stripe' : 'Secure payment via Stripe'}
                        </p>
                      </div>
                    </a>
                    <a href="https://book.stripe.com/14A3cucxT2QIgIWdwB3cc01" target="_blank" rel="noopener noreferrer" className="flex items-center space-x-3 px-5 py-4 hover:bg-beige transition-colors" onClick={() => setPayOpen(false)} data-id="element-203">
                      <GraduationCap className="w-5 h-5 text-gold flex-shrink-0" data-id="element-204" />
                      <div data-id="element-205">
                        <p className="font-bold text-dark text-sm" data-id="element-206">
                          {language === 'es' ? 'Inscripción Master Class' : 'Master Class Enrollment'}
                        </p>
                        <p className="text-xs text-dark/50" data-id="element-207">
                          {language === 'es' ? 'Reserva tu lugar' : 'Reserve your spot'}
                        </p>
                      </div>
                    </a>
                  </motion.div>}
              </AnimatePresence>
            </div>
          </nav>

          {/* Mobile Actions */}
          <div className="md:hidden flex items-center space-x-1.5" data-id="element-208">
            {/* Language Toggle Mobile */}
            <button onClick={toggleLanguage} className="flex items-center space-x-0.5 text-[10px] font-bold border border-gold/30 rounded-full px-1.5 py-0.5 hover:bg-gold/10 transition-colors" data-id="element-209">
              <span className={language === 'es' ? 'text-gold-dark' : 'text-dark/50'} data-id="element-210">
                ES
              </span>
              <span className="text-dark/30" data-id="element-211">|</span>
              <span className={language === 'en' ? 'text-gold-dark' : 'text-dark/50'} data-id="element-212">
                EN
              </span>
            </button>

            {/* WhatsApp Mobile — icon only */}
            <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="flex items-center space-x-1 bg-gold text-white px-2 py-1.5 rounded-sm text-[11px] font-medium" data-id="element-213">
              <MessageCircle className="w-3 h-3" data-id="element-214" />
              <span data-id="element-215">{t('header', 'bookMobile')}</span>
            </a>

            {/* Pagar Mobile */}
            <div className="relative" ref={dropdownRef} data-id="element-216">
              <button onClick={() => setPayOpen(!payOpen)} className="flex items-center space-x-1 border border-gold text-gold px-2 py-1.5 rounded-sm text-[11px] font-medium" data-id="element-217">
                <CreditCard className="w-3 h-3" data-id="element-218" />
                <span data-id="element-219">{language === 'es' ? 'Pagar' : 'Pay'}</span>
                <ChevronDown className={`w-2.5 h-2.5 transition-transform duration-300 ${payOpen ? 'rotate-180' : ''}`} data-id="element-220" />
              </button>
              <AnimatePresence data-id="element-221">
                {payOpen && <motion.div initial={{
                opacity: 0,
                y: -8
              }} animate={{
                opacity: 1,
                y: 0
              }} exit={{
                opacity: 0,
                y: -8
              }} transition={{
                duration: 0.2
              }} className="absolute right-0 mt-2 w-56 bg-white border border-gold/20 rounded-sm shadow-xl overflow-hidden z-50" data-id="element-222">
                    <a href="https://buy.stripe.com/bJedR855raja78m6493cc02" target="_blank" rel="noopener noreferrer" className="flex items-center space-x-3 px-4 py-3 hover:bg-beige transition-colors border-b border-gold/10" onClick={() => setPayOpen(false)} data-id="element-223">
                      <CalendarCheck className="w-4 h-4 text-gold flex-shrink-0" data-id="element-224" />
                      <span className="font-medium text-dark text-xs" data-id="element-225">
                        {language === 'es' ? 'Pagar Cita' : 'Pay Appointment'}
                      </span>
                    </a>
                    <a href="https://book.stripe.com/14A3cucxT2QIgIWdwB3cc01" target="_blank" rel="noopener noreferrer" className="flex items-center space-x-3 px-4 py-3 hover:bg-beige transition-colors" onClick={() => setPayOpen(false)} data-id="element-226">
                      <GraduationCap className="w-4 h-4 text-gold flex-shrink-0" data-id="element-227" />
                      <span className="font-medium text-dark text-xs" data-id="element-228">
                        {language === 'es' ? 'Master Class' : 'Master Class'}
                      </span>
                    </a>
                  </motion.div>}
              </AnimatePresence>
            </div>
          </div>
        </div>
        {/* Mobile nav links */}
        <nav className="md:hidden flex flex-wrap justify-center gap-x-4 gap-y-1 pb-3 border-t border-gold/10 pt-2" data-id="element-229">
          <a href="#servicios" className="text-xs font-medium text-dark/70 hover:text-gold transition-colors" data-id="element-230">
            {t('header', 'services')}
          </a>
          <a href="#sobre-lorena" className="text-xs font-medium text-dark/70 hover:text-gold transition-colors" data-id="element-231">
            {t('header', 'about')}
          </a>
          <a href="#testimonios" className="text-xs font-medium text-dark/70 hover:text-gold transition-colors" data-id="element-232">
            {t('header', 'testimonials')}
          </a>
          <a href="#productos" className="text-xs font-medium text-dark/70 hover:text-gold transition-colors" data-id="element-233">
            {t('header', 'products')}
          </a>
          <a href="#espacio" className="text-xs font-medium text-dark/70 hover:text-gold transition-colors" data-id="element-234">
            {t('header', 'space')}
          </a>
          <a href="#formacion" className="text-xs font-medium text-dark/70 hover:text-gold transition-colors" data-id="element-235">
            {t('header', 'training')}
          </a>
          <a href="#contacto" className="text-xs font-medium text-dark/70 hover:text-gold transition-colors" data-id="element-236">
            {t('header', 'contact')}
          </a>
        </nav>
      </div>
    </header>;
}